<div class="ui-fileupload-buttonbar ui-widget-header-collateral ui-corner-top">
  <span
    class="ui-fileupload-choose button fm-primary-button text-span-display"
    [ngClass]="{ 'ui-state-focus': focus }"
    >{{ buttonLabel }}
    <ng-container *ngIf="multiple">
      <input
        #fileinput
        type="file"
        (change)="handleFile($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        multiple
      />
    </ng-container>
    <ng-container *ngIf="!multiple">
      <input
        #fileinput
        type="file"
        (change)="handleFile($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
      />
    </ng-container>
  </span>
</div>
